import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Folder } from "~/api/model";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";

interface RestoreCaseDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  folder: Folder;
  onCaseRestored: (folderId: string) => Promise<void>;
}

export const RestoreCaseDialog: FC<RestoreCaseDialogProps> = ({
  open,
  setOpen,
  folder,
  onCaseRestored,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <FormattedMessage
              id="restoreCase.title"
              defaultMessage="Restore Case"
            />
          </AlertDialogTitle>
          <AlertDialogDescription>
            <FormattedMessage
              id="restoreCase.description"
              defaultMessage="{caseName} will be restored."
              values={{ caseName: <strong>{folder.name}</strong> }}
            />{" "}
            {folder.fileCount > 0 && (
              <FormattedMessage
                id="restoreCase.description.suffix"
                defaultMessage="{documentsCount} documents will be restored with the case."
                values={{
                  documentsCount: <strong>{folder.fileCount}</strong>,
                }}
              />
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => setOpen(false)}>
            <FormattedMessage id="cancel" />
          </AlertDialogCancel>
          <AlertDialogAction onClick={() => onCaseRestored(folder.id)}>
            <FormattedMessage id="restore" />
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
